<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import appConfig from "@/app.config";
import MaskedInput from "vue-text-mask";
import Loader from "@/components/widgets/loader";
import {required, minValue} from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

Vue.component("v-select", vSelect);
import Toasted from "vue-toasted";


Vue.use(Toasted);
export default {
  page: {
    title: "Créditos",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    DatePicker,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      cantidad_sugerida: 0,
      totalDeuda: 0,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      fechaN: new Date(),
      // variables metodos
      bandera: false,
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
      //
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      totalModal: "",
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "venta_cerdos/credito",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formCre: {
        nombre: "",
        saldo: 0,
        id: 0,
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Créditos",
      itemst: [
        {
          text: "Ventas",
          href: "/",
        },
        {
          text: "Créditos",
          active: true,
        },
      ],
      fields: [
        
      {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "5%",
        },
        {
          name: "no_ducumento_v",
          title: "No. venta",
          sortField: "no_ducumento_v",
          // width: "5%",
        },
        // {
        //   name: "no_factura_c",
        //   title: "No. Factura",
        //   sortField: "no_factura_c",
        //   width: "5%",
        // },
        {
          name: "empleado",
          title: "Usuario",
          sortField: "empleado",
          // width: "15%",
        },
        {
          name: "cliente",
          title: "Cliente",
          // sortField: "dproveedore.company_proveedor",
          // width: "15%",
        },
        {
          name: "fechac",
          title: "Fecha venta",
          sortField: "fechac",
          // width: "10%",
        },
        {
          name: "fechalimite",
          title: "Fecha límite",
          sortField: "fechalimite",
          // width: "10%",
        },
        {
          name: "saldo",
          title: "Saldo",
          sortField: "saldo",
          // width: "10%",
        },
        {
          name: "total",
          title: "Total",
          sortField: "total",
          // width: "10%",
        },
        {
          name: "cuota",
          title: "Cuota",
          // sortField: "total",
          // width: "10%",
        },
        {
          name: "estado3",
          title: "Estado crédito",
          titleClass: "",
          dataClass: "text-muted",
          // width: "5%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "estado2",
          dataClass: "text-muted",
          // width: "5%",
        },
      ],
      searchType: [
        {nombre: "No. Venta", value: "no_venta"},
        {nombre: "Cliente", value: "cliente"},
        {nombre: "Empleado", value: "empleado"},
        {nombre: "Fecha venta", value: "fecha"},
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_credito",
      sortDesc: false,
      searchLabel: {nombre: "Venta", value: "no_venta"},
      filterLabel: {nombre: "Venta", value: "no_venta"},
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      validateArqueo : false,
      dataCierre: null,
    };
  },
  validations: {
    formCre: {
      nombre: {required},
    },
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
    transferencia: {
      required,
      $each: {
        cantidad_transferencia: {
          required,
          // minValue: minValue(1),
        },
        transaccion_transferencia: {
          required,
        },
      },
    },
    deposito: {
      required,
      $each: {
        cantidad_deposito: {
          required,
          // minValue: minValue(1),
        },
        transaccion_deposito: {
          required,
        },
      },
    },
    cheque: {
      required,
      $each: {
        cantidad_cheque: {
          required,
          // minValue: minValue(1),
        },
        transaccion_cheque: {
          required,
        },
      },
    },
    tarjeta: {
      required,
      $each: {
        cantidad_tarjeta: {
          required,
          // minValue: minValue(1),
        },
        transaccion_tarjeta: {
          required,
        },
      },
    },
    montoFinal: {
      cantidad: {
        minValue: minValue(1),
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
    // this.validarCaja();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    fechaLimite(data) {
      if(data.length>0){
        const largo = data.distribucion_pagos[0].distribucion_detalles.length;
        return data.distribucion_pagos[0].distribucion_detalles[largo - 1].fecha_pago;

      }
    },
    validarCaja() {
      axios
          .get(
              process.env.VUE_APP_URL +
              "caja/get_validate?" +
              "&usuario=" +
              this.userT.id + "&tienda=" + this.$store.state.authfack.user.tienda,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
              this.validateArqueo =
                response.data.validate == "null" ||
                response.data.validate == "" ||
                response.data.validate == null
                  ? false
                  : true;
              this.dataCierre = response.data.validate;
  
              // console.log(this.validateArqueo,   this.dataCierre );
          });
    },
    cuota(data) {
      const largo = data.distribucion_pagos[0].distribucion_detalles.length;
      return data.distribucion_pagos[0].distribucion_detalles[largo - 1].monto_pago;
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      if (opc == "save") {
        if (this.montoFinal.cantidad > 0) {
          if (
              this.checkMoney.efectivo ||
              this.checkMoney.transferencia ||
              this.checkMoney.deposito ||
              this.checkMoney.cheque ||
              this.checkMoney.tarjeta
          ) {
            this.bandera = false;
            if (this.checkMoney.efectivo) {
              if (this.converMaskToNumberxd(this.cantidad_efectivo) == "") {
                this.bandera = true;
                Vue.toasted.error("Agregue monto en efectivo", this.options);
              } else {
                this.montos.monto_efectivo = parseFloat(
                    this.converMaskToNumberxd(this.cantidad_efectivo)
                );
              }
            }
            if (this.checkMoney.transferencia) {
              let temp = 0;
              for (let i = 0; i < this.transferencia.length; i++) {
                if (
                    this.transferencia[i].cantidad_transferencia == "" ||
                    this.transferencia[i].transaccion_transferencia == ""
                ) {
                  temp++;
                }
              }
              if (temp > 0) {
                this.bandera = true;
                Vue.toasted.error(
                    "Complete campos de transferencia",
                    this.options
                );
              } else {
                this.montos.monto_transferencia = [];
                for (let i = 0; i < this.transferencia.length; i++) {
                  this.montos.monto_transferencia.push({
                    monto_transferencia: parseFloat(
                        this.converMaskToNumberxd(
                            this.transferencia[i].cantidad_transferencia
                        )
                    ),
                    transaccion_transferencia: this.transferencia[i]
                        .transaccion_transferencia,
                  });
                }
              }
            }
            if (this.checkMoney.deposito) {
              let temp = 0;
              for (let i = 0; i < this.deposito.length; i++) {
                if (
                    this.deposito[i].cantidad_deposito == "" ||
                    this.deposito[i].transaccion_deposito == ""
                ) {
                  temp++;
                }
              }
              if (temp > 0) {
                this.bandera = true;
                Vue.toasted.error("Complete campos de deposito", this.options);
              } else {
                this.montos.monto_deposito = [];
                for (let i = 0; i < this.deposito.length; i++) {
                  this.montos.monto_deposito.push({
                    monto_deposito: parseFloat(
                        this.converMaskToNumberxd(
                            this.deposito[i].cantidad_deposito
                        )
                    ),
                    transaccion_deposito: this.deposito[i].transaccion_deposito,
                  });
                }
              }
            }
            if (this.checkMoney.cheque) {
              let temp = 0;
              for (let i = 0; i < this.cheque.length; i++) {
                if (
                    this.cheque[i].cantidad_cheque == "" ||
                    this.cheque[i].transaccion_cheque == ""
                ) {
                  temp++;
                }
              }
              if (temp > 0) {
                this.bandera = true;
                Vue.toasted.error("Complete campos de cheque", this.options);
              } else {
                this.montos.monto_cheque = [];
                for (let i = 0; i < this.cheque.length; i++) {
                  this.montos.monto_cheque.push({
                    monto_cheque: parseFloat(
                        this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                    ),
                    transaccion_cheque: this.cheque[i].transaccion_cheque,
                  });
                }
              }
            }
            if (this.checkMoney.tarjeta) {
              let temp = 0;
              for (let i = 0; i < this.tarjeta.length; i++) {
                if (
                    this.tarjeta[i].cantidad_tarjeta == "" ||
                    this.tarjeta[i].transaccion_tarjeta == ""
                ) {
                  temp++;
                }
              }
              if (temp > 0) {
                this.bandera = true;
                Vue.toasted.error("Complete campos de tarjeta", this.options);
              } else {
                this.montos.monto_tarjeta = [];
                for (let i = 0; i < this.tarjeta.length; i++) {
                  this.montos.monto_tarjeta.push({
                    monto_tarjeta: parseFloat(
                        this.converMaskToNumberxd(
                            this.tarjeta[i].cantidad_tarjeta
                        )
                    ),
                    transaccion_tarjeta: this.tarjeta[i].transaccion_tarjeta,
                  });
                }
              }
            }
            if (this.bandera == false) {
              if (this.montoFinal.cantidad <= this.totalModal) {
                this.showModalL = true;
                this.abonar();
              } else {
                Vue.toasted.error(
                    `La cantidad actual no coincide con el monto a pagar. La diferencia es de <strong>${this.money(
                        this.montoFinal.cantidad - this.totalModal
                    )}</strong>`,
                    this.options
                );
              }
            } else {
              Vue.toasted.error(
                  "Ingrese cantidades en los métodos de pago",
                  this.options
              );
            }
          } else {
            Vue.toasted.error(
                "Seleccione al menos un método de pago",
                this.options
            );
          }
        } else {
          Vue.toasted.error("Agregue métodos de pago", this.options);
        }
      }
    },

    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
            number.charAt(i) === "Q" ||
            number.charAt(i) === "€" ||
            number.charAt(i) === "$" ||
            number.charAt(i) === "%" ||
            number.charAt(i) === "," ||
            number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Metodos de pago

    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.cantidad_efectivo = "";
        this.sumarCantidades();
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.transferencia = [
          {
            cantidad_transferencia: "",
            transaccion_transferencia: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "deposito" && !this.checkMoney.deposito) {
        this.deposito = [
          {
            cantidad_deposito: "",
            transaccion_deposito: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.cheque = [
          {
            cantidad_cheque: "",
            transaccion_cheque: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "tarjeta" && !this.checkMoney.tarjeta) {
        this.cheque = [
          {
            cantidad_tarjeta: "",
            transaccion_tarjeta: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
    },
    sumarCantidades() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      let sum4 = 0;
      let sum5 = 0;

      if (this.checkMoney.efectivo) {
        sum =
            parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo)) > 0
                ? parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo))
                : 0;
        // this.validarCantidades.efectivo = sum;
      }

      if (this.checkMoney.transferencia) {
        for (let i = 0; i < this.transferencia.length; i++) {
          sum2 =
              sum2 +
              (parseFloat(
                  this.converMaskToNumberxd(
                      this.transferencia[i].cantidad_transferencia
                  )
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(
                          this.transferencia[i].cantidad_transferencia
                      )
                  )
                  : 0);
        }
      }

      if (this.checkMoney.deposito) {
        for (let i = 0; i < this.deposito.length; i++) {
          sum3 =
              sum3 +
              (parseFloat(
                  this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
                  )
                  : 0);
        }
      }

      if (this.checkMoney.cheque) {
        for (let i = 0; i < this.cheque.length; i++) {
          sum4 =
              sum4 +
              (parseFloat(
                  this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                  )
                  : 0);
        }
      }

      if (this.checkMoney.tarjeta) {
        for (let i = 0; i < this.tarjeta.length; i++) {
          sum5 =
              sum5 +
              (parseFloat(
                  this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
                  )
                  : 0);
        }
      }

      this.montoFinal.cantidad = sum + sum2 + sum3 + sum4 + sum5;

      // if (accion == 1) {
      //   this.montoFinal.cantidad = parseFloat(
      //     this.converMaskToNumberxd(cantidad)
      //   );
      // } else {
      //   this.montoFinal.transaccion = cantidad;
      // }
    },
    onButton(action, index) {
      if (action == "transferencia-plus") {
        this.transferencia.push({
          transaccion_transferencia: "",
          cantidad_transferencia: "",
          button: false,
        });
      }
      if (action == "transferencia-minus") {
        this.transferencia.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "deposito-plus") {
        this.deposito.push({
          transaccion_deposito: "",
          cantidad_deposito: "",
          button: false,
        });
      }
      if (action == "deposito-minus") {
        this.deposito.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "cheque-plus") {
        this.cheque.push({
          transaccion_cheque: "",
          cantidad_cheque: "",
          button: false,
        });
      }
      if (action == "cheque-minus") {
        this.cheque.splice(index, 1);
        this.sumarCantidades();
      }

      if (action == "tarjeta-plus") {
        this.tarjeta.push({
          transaccion_tarjeta: "",
          cantidad_tarjeta: "",
          button: false,
        });
      }
      if (action == "tarjeta-minus") {
        this.tarjeta.splice(index, 1);
        this.sumarCantidades();
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    limpiarfiltro() {
      let me = this;
      me.fecha_inicio = "";
      me.fecha_fin = "";
    },
    separarfechas() {
      this.fecha_inicio = this.rangode_fecha[0];
      this.fecha_fin = this.rangode_fecha[1];
    },
    activarBuscadorFechas(search, index) {
      this.metododeBusqueda = index == 3 ? true : false;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date)
          .locale("es")
          .utc()
          .format("MMM Do YYYY");
    },

    //Desactivar registro
    pagar() {
      const {id, nombre} = this.formCre;
      axios
          .put(
              process.env.VUE_APP_URL + "venta_cerdos/pagarCredito",
              {
                id: id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.showModalD = false;
            Vue.toasted.error(
                "Factura: " + nombre + " Compra Pagada",
                this.options
            );
            const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para desactivar", this.options);
          });
    },
    arrayMetodos() {
      this.metodos_pagando = {
        monto_efectivo: "",
        monto_tarjeta: [],
        monto_transferencia: [],
      };
      if (this.montoFinal.metodo === "Efectivo") {
        this.metodos_pagando.monto_efectivo = parseFloat(
            this.montoFinal.cantidad
        );
      } else if (this.montoFinal.metodo === "Transferencia") {
        this.metodos_pagando.monto_transferencia.push({
          monto_transferencia: parseFloat(this.montoFinal.cantidad),
          transaccion_transferencia: this.montoFinal.transaccion,
        });
      } else if (this.montoFinal.metodo === "Tarjeta") {
        this.metodos_pagando.monto_tarjeta.push({
          monto_tarjeta: parseFloat(this.montoFinal.cantidad),
          transaccion_tarjeta: this.montoFinal.transaccion,
        });
      }
      return this.metodos_pagando;
    },
    //Pagar  la deuda con  cierta parte de la cantidad o toda
    abonar() {
      // console.log("guarda abono");
      const {id, nombre} = this.formCre;
      console.log(id,nombre);
      const pagadaTotal = this.totalModal == this.montoFinal.cantidad ? 1 : 0;
      // const fecha = this.customFormatter(this.fechaN);
      // const metodosT = this.arrayMetodos();
      // console.log(metodosT);
      axios
          .put(
              process.env.VUE_APP_URL + "venta_cerdos/pagarCredito",
              {
                id: id,
                usuario: this.userT.id,
                montos: this.montos,
                total_pagado: this.montoFinal.cantidad,
                estado: pagadaTotal,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.showModalA = false;
            this.showModalL = false;
            Vue.toasted.info("Venta: " + nombre+ " abonada", this.options);
            const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para abonar", this.options);
          });
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      this.totalDeuda = paginationData.totalDeuda
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async reciboVenta(id){
      this.showModalL= true;
      const urlas = process.env.VUE_APP_URL + "venta_cerdos/recibo_credito?id="+id;
          
          const response = await axios({
          url: urlas, 
        
          headers: { "x-token": this.userT.token },
        
          method: 'GET',
          responseType: 'blob', // Importante para recibir el PDF como un Blob binario
          });
          // Crear un enlace temporal para forzar la descarga
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'recibo.pdf'); // Nombre del archivo de descarga
          document.body.appendChild(link);
          link.click(); // Forzar el clic para descargar
          // Eliminar el enlace temporal
          document.body.removeChild(link);
          this.showModalL= false;
    },
    async changeTypeDates() {
      await this.separarfechas();
      // console.log(this.fecha_inicio, this.fecha_fin);
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? "" : "";
      this.fecha_fin = type.value == "fecha" ? "" : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
          ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda : this.$store.state.authfack.user.tienda
          }
          : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda : this.$store.state.authfack.user.tienda
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          // console.log("limpiando variables");

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.bandera = false;
      this.cantidad_efectivo = "";
      this.transferencia = [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ];
      this.deposito = [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ];
      this.cheque = [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ];
      this.tarjeta = [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ];
      this.checkMoney = {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      };
      this.checkSelect = {
        efectivo: false,
        deposito: false,
        cheque: false,
        transferencia: false,
        tarjeta: false,
      };
      this.montoFinal = {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      };
      this.montos = {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      };
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "desactivate-item") {
        this.totalModal = data.saldo_credito_v;
        this.formCre.nombre = data.no_ducumento_v;
        this.formCre.id = data.id;
        this.formCre.saldo = data.saldo_credito_v;
        this.showModalD = true;
      }
      if (action == "abonar-item") {
        // console.log(data);
        this.cantidad_sugerida =
            parseFloat(data.total_v) / data.distribucion_pagos[0].cantidad_pagos;
        this.totalModal = data.saldo_credito_v;
        this.formCre.nombre = data.no_ducumento_v;
        this.formCre.id = data.id;
        this.formCre.saldo = data.saldo_credito_v;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">
        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Actualizar creditos -->
        <b-modal
            centered
            v-model="showModalA"
            @show="openModal('save')"
            @hidden="openModal('save')"
            size="lg"
            title="Abonar crédito"
            title-class="text-black font-18"
            body-class="p-3"
        >
          <b-card no-body>
            <b-tabs pills vertical nav-wrapper-class="col-sm-4">
              <!-- Efectivo -->
              <b-tab :disabled="checkSelect.efectivo">
                <template v-slot:title>
                  <b-form-checkbox v-model="checkMoney.efectivo">
                    &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                      Efectivo</span
                  >&nbsp;
                    <i class="fas fa-money-bill"> </i>
                  </b-form-checkbox>
                </template>

                <b-card bg-variant="primary bg-soft">
                  <b-form-checkbox
                      v-model="checkMoney.efectivo"
                      @input="checkboxChange('efectivo')"
                  >&nbsp;&nbsp;Usar método de pago
                  </b-form-checkbox>
                  <br/>
                  <b-form-group label="MONTO">
                    <masked-input
                        :disabled="!checkMoney.efectivo"
                        v-model.trim="$v.cantidad_efectivo.$model"
                        :mask="mask_quetzal"
                        :guide="false"
                        :keep-char-positions="true"
                        :show-mask="true"
                        type="text"
                        @input="sumarCantidades()"
                        placeholder="Ingresar el monto a pagar"
                        :class="{
                        'is-invalid': $v.cantidad_efectivo.$error,
                      }"
                        class="form-control"
                    />
                    <div
                        v-if="checkMoney.efectivo"
                        :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.cantidad_efectivo.$invalid &&
                          !$v.cantidad_efectivo.$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                    <!-- <div
                        v-if="validarCantidades.efectivo <= 0"
                        :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.validarCantidades.efectivo.$error &&
                            !$v.validarCantidades.efectivo.minValue,
                        }"
                      >
                        La cantidad debe ser mayor a cero
                      </div> -->
                  </b-form-group>
                </b-card>
              </b-tab>
              <!-- Transferencia -->
              <b-tab :disabled="checkSelect.transferencia">
                <template v-slot:title>
                  <b-form-checkbox v-model="checkMoney.transferencia">
                    &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                      Transferencia</span
                  >&nbsp;
                    <i class="bx bx-transfer-alt"> </i>
                  </b-form-checkbox>
                </template>

                <b-card bg-variant="primary bg-soft">
                  <b-form-checkbox
                      v-model="checkMoney.transferencia"
                      @input="checkboxChange('transferencia')"
                  >
                    &nbsp;&nbsp;Usar método de pago
                  </b-form-checkbox>
                  <br/>
                  <div
                      v-for="(item, index) in transferencia"
                      v-bind:key="index"
                  >
                    <b-form-group
                        :label="'NÚMERO DE TRANSACCIÓN' + ' ' + (index + 1)"
                        class="has-float-label"
                    >
                      <b-input-group>
                        <b-form-input
                            :disabled="!checkMoney.transferencia"
                            :class="{
                            'is-invalid':
                              $v.transferencia.$each.$iter[index]
                                .transaccion_transferencia.$error,
                          }"
                            v-model.trim="item.transaccion_transferencia"
                            placeholder="Ingresar en número de transacción"
                            @input="sumarCantidades()"
                        >
                        </b-form-input>
                        <b-input-group-append v-if="item.button">
                          <b-button
                              :disabled="!checkMoney.transferencia"
                              variant="primary"
                              @click="onButton('transferencia-plus')"
                          ><i :class="'bx bx-plus-medical'"
                          /></b-button>
                        </b-input-group-append>
                        <b-input-group-append v-if="!item.button">
                          <b-button
                              variant="primary"
                              @click="onButton('transferencia-minus', index)"
                          ><i :class="'bx bx-undo'"
                          /></b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                          v-if="checkMoney.transferencia"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.transferencia.$each.$iter[index]
                              .transaccion_transferencia.$invalid &&
                            !$v.transferencia.$each.$iter[index]
                              .transaccion_transferencia.$invalid.required,
                        }"
                      >
                        Debe ingresar el número de transacción
                      </div>
                    </b-form-group>
                    <br/>
                    <b-form-group label="MONTO">
                      <masked-input
                          :disabled="!checkMoney.transferencia"
                          v-model.trim="item.cantidad_transferencia"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                          'is-invalid':
                            $v.transferencia.$each.$iter[index]
                              .cantidad_transferencia.$error,
                        }"
                          class="form-control"
                      />
                      <div
                          v-if="checkMoney.transferencia"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.transferencia.$each.$iter[index]
                              .cantidad_transferencia.$invalid &&
                            !$v.transferencia.$each.$iter[index]
                              .cantidad_transferencia.$invalid.required,
                        }"
                      >
                        Debe ingresar el monto
                      </div>
                    </b-form-group>
                    <hr/>
                  </div>
                </b-card>
              </b-tab>
              <!-- Deposito -->
              <b-tab :disabled="checkSelect.deposito">
                <template v-slot:title>
                  <b-form-checkbox v-model="checkMoney.deposito">
                    &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                      Deposito</span
                  >&nbsp;
                    <i class="bx bxs-downvote"> </i>
                  </b-form-checkbox>
                </template>

                <b-card bg-variant="primary bg-soft">
                  <b-form-checkbox
                      v-model="checkMoney.deposito"
                      @input="checkboxChange('deposito')"
                  >&nbsp;&nbsp;Usar método de pago
                  </b-form-checkbox>
                  <br/>
                  <div v-for="(item, index) in deposito" v-bind:key="index">
                    <b-form-group
                        :label="'NÚMERO DE DEPOSITO' + ' ' + (index + 1)"
                        class="has-float-label"
                    >
                      <b-input-group>
                        <b-form-input
                            :disabled="!checkMoney.deposito"
                            :class="{
                            'is-invalid':
                              $v.deposito.$each.$iter[index]
                                .transaccion_deposito.$error,
                          }"
                            v-model.trim="item.transaccion_deposito"
                            placeholder="Ingresar en número deposito"
                            @input="sumarCantidades()"
                        >
                        </b-form-input>
                        <b-input-group-append v-if="item.button">
                          <b-button
                              :disabled="!checkMoney.deposito"
                              variant="primary"
                              @click="onButton('deposito-plus')"
                          >
                            <i :class="'bx bx-plus-medical'"/>
                          </b-button>
                        </b-input-group-append>
                        <b-input-group-append v-if="!item.button">
                          <b-button
                              variant="primary"
                              @click="onButton('deposito-minus', index)"
                          ><i :class="'bx bx-undo'"/>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                          v-if="checkMoney.deposito"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.deposito.$each.$iter[index].transaccion_deposito
                              .$invalid &&
                            !$v.deposito.$each.$iter[index].transaccion_deposito
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el número de deposito
                      </div>
                    </b-form-group>
                    <br/>
                    <b-form-group label="MONTO">
                      <masked-input
                          :disabled="!checkMoney.deposito"
                          v-model.trim="item.cantidad_deposito"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                          'is-invalid':
                            $v.deposito.$each.$iter[index].cantidad_deposito
                              .$error,
                        }"
                          class="form-control"
                      />
                      <div
                          v-if="checkMoney.deposito"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.deposito.$each.$iter[index].cantidad_deposito
                              .$invalid &&
                            !$v.deposito.$each.$iter[index].cantidad_deposito
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el monto
                      </div>
                    </b-form-group>
                    <hr/>
                  </div>
                </b-card>
              </b-tab>
              <!-- Cheque -->
              <b-tab :disabled="checkSelect.cheque">
                <template v-slot:title>
                  <b-form-checkbox v-model="checkMoney.cheque">
                    &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                      Cheque</span
                  >&nbsp;
                    <i class="bx bx-dock-top"> </i>
                  </b-form-checkbox>
                </template>

                <b-card bg-variant="primary bg-soft">
                  <b-form-checkbox
                      v-model="checkMoney.cheque"
                      @input="checkboxChange('cheque')"
                  >&nbsp;&nbsp;Usar método de pago
                  </b-form-checkbox>
                  <br/>
                  <div v-for="(item, index) in cheque" v-bind:key="index">
                    <b-form-group
                        :label="'NÚMERO DE CHEQUE' + ' ' + (index + 1)"
                        class="has-float-label"
                    >
                      <b-input-group>
                        <b-form-input
                            :disabled="!checkMoney.cheque"
                            :class="{
                            'is-invalid':
                              $v.cheque.$each.$iter[index].transaccion_cheque
                                .$error,
                          }"
                            v-model.trim="item.transaccion_cheque"
                            placeholder="Ingresar en número dcheque"
                            @input="sumarCantidades()"
                        >
                        </b-form-input>
                        <b-input-group-append v-if="item.button">
                          <b-button
                              :disabled="!checkMoney.cheque"
                              variant="primary"
                              @click="onButton('cheque-plus')"
                          ><i :class="'bx bx-plus-medical'"
                          /></b-button>
                        </b-input-group-append>
                        <b-input-group-append v-if="!item.button">
                          <b-button
                              variant="primary"
                              @click="onButton('cheque-minus', index)"
                          ><i :class="'bx bx-undo'"/>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                          v-if="checkMoney.cheque"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.cheque.$each.$iter[index].transaccion_cheque
                              .$invalid &&
                            !$v.cheque.$each.$iter[index].transaccion_cheque
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el número dcheque
                      </div>
                    </b-form-group>
                    <br/>
                    <b-form-group label="MONTO">
                      <masked-input
                          :disabled="!checkMoney.cheque"
                          v-model.trim="item.cantidad_cheque"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                          'is-invalid':
                            $v.cheque.$each.$iter[index].cantidad_cheque.$error,
                        }"
                          class="form-control"
                      />
                      <div
                          v-if="checkMoney.cheque"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.cheque.$each.$iter[index].cantidad_cheque
                              .$invalid &&
                            !$v.cheque.$each.$iter[index].cantidad_cheque
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el monto
                      </div>
                    </b-form-group>
                    <hr/>
                  </div>
                </b-card>
              </b-tab>
              <!-- Tarjeta -->
              <b-tab :disabled="checkSelect.tarjeta">
                <template v-slot:title>
                  <b-form-checkbox v-model="checkMoney.tarjeta">
                    &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                      Tarjeta</span
                  >&nbsp;
                    <i class="far fa-credit-card"> </i>
                  </b-form-checkbox>
                </template>

                <b-card bg-variant="primary bg-soft">
                  <b-form-checkbox
                      v-model="checkMoney.tarjeta"
                      @input="checkboxChange('tarjeta')"
                  >&nbsp;&nbsp;Usar método de pago
                  </b-form-checkbox>
                  <br/>
                  <div v-for="(item, index) in tarjeta" v-bind:key="index">
                    <b-form-group
                        :label="
                        'NÚMERO DE TRANSACCIÓN TARJETA' + ' ' + (index + 1)
                      "
                        class="has-float-label"
                    >
                      <b-input-group>
                        <b-form-input
                            :disabled="!checkMoney.tarjeta"
                            :class="{
                            'is-invalid':
                              $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                                .$error,
                          }"
                            v-model.trim="item.transaccion_tarjeta"
                            placeholder="Ingresar en número tarjeta"
                            @input="sumarCantidades()"
                        >
                        </b-form-input>
                        <b-input-group-append v-if="item.button">
                          <b-button
                              :disabled="!checkMoney.tarjeta"
                              variant="primary"
                              @click="onButton('tarjeta-plus')"
                          ><i :class="'bx bx-plus-medical'"
                          /></b-button>
                        </b-input-group-append>
                        <b-input-group-append v-if="!item.button">
                          <b-button
                              variant="primary"
                              @click="onButton('tarjeta-minus', index)"
                          ><i :class="'bx bx-undo'"/>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                          v-if="checkMoney.tarjeta"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                              .$invalid &&
                            !$v.tarjeta.$each.$iter[index].transaccion_tarjeta
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el número de transacción de tarjeta
                      </div>
                    </b-form-group>
                    <br/>
                    <b-form-group label="MONTO">
                      <masked-input
                          :disabled="!checkMoney.tarjeta"
                          v-model.trim="item.cantidad_tarjeta"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                          'is-invalid':
                            $v.tarjeta.$each.$iter[index].cantidad_tarjeta
                              .$error,
                        }"
                          class="form-control"
                      />
                      <div
                          v-if="checkMoney.tarjeta"
                          :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.tarjeta.$each.$iter[index].cantidad_tarjeta
                              .$invalid &&
                            !$v.tarjeta.$each.$iter[index].cantidad_tarjeta
                              .$invalid.required,
                        }"
                      >
                        Debe ingresar el monto
                      </div>
                    </b-form-group>
                    <hr/>
                  </div>
                </b-card>
              </b-tab>
            </b-tabs>
            <br/>
            <h5>Cantidad sugerida: {{ money(cantidad_sugerida) }}</h5>
            <div class="row">
              <div class="col">
                <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                  <h4 class="mt-0 mb-4 text-white">
                    <i class="bx bx-money me-3"></i> Total a pagar
                  </h4>
                  <h3 class="mt-0 mb-4 text-white" align="center">
                    {{ money(totalModal > 0 ? totalModal : 0.0) }}
                  </h3>
                </b-card>
              </div>
              <div class="col">
                <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                  <h4 class="mt-0 mb-4 text-white">
                    <i class="bx bx-list-check me-3"></i> Restante
                  </h4>
                  <h3 class="mt-0 mb-4 text-white" align="center">
                    {{
                      money(
                          (totalModal > 0 ? totalModal : 0.0) -
                          montoFinal.cantidad
                      )
                    }}
                  </h3>
                </b-card>
              </div>
              <div class="col">
                <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                  <h4 class="mt-0 mb-4 text-white">
                    <i class="bx bx-detail me-3"></i> Pagando
                  </h4>
                  <h3 class="mt-0 mb-4 text-white" align="center">
                    {{
                      money(
                          montoFinal.cantidad >= 0 ? montoFinal.cantidad : 0.0
                      )
                    }}
                  </h3>
                </b-card>
              </div>
            </div>
          </b-card>

          <template #modal-footer="{}">
            <b-button variant="light" @click="showModalA = false"
            >Cancelar
            </b-button
            >
            <b-button variant="danger" @click="validaciones('save')"
            >Pagar
            </b-button
            >
          </template>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
            centered
            v-model="showModalD"
            title="Aprobar"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea cancelar toda la deuda? <br/></h4>
                  <h5>Venta: {{ this.formCre.nombre }}</h5>
                  <h5>Total a pagar: {{ money(this.totalModal) }}</h5>
                  <h5>Toda la deuda se cancelara en efectivo</h5>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
              >Cancelar
              </b-button
              >
              <b-button variant="danger" @click="pagar">Pagar todo</b-button>
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de créditos</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2 ">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end "
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="
                          changeTypeSearch(search);
                          activarBuscadorFechas(search, index);
                          limpiarfiltro();
                        "
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-3 " v-if="metododeBusqueda">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end "
                >
                  <label class="d-inline-flex align-items-center">
                    <date-picker
                        v-model="rangode_fecha"
                        range
                        append-to-body
                        lang="en"
                        confirm
                        confirm-text="Aceptar"
                        @input="changeTypeDates()"
                    ></date-picker>
                  </label>
                </div>
              </div>

              <div
                  class="col-sm-12 col-md-3 text-md-start"
                  v-if="metododeBusqueda == false"
              >
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm "
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <div  v-if="userT.role == 1 || userT.role == '1'" class="col-sm-12 col-md-2 text-center mt-3 mt-md-0">
              <div class="bg-light border rounded py-2 px-3 shadow-sm">
                <span class="text-muted small">Total de deuda</span>
                <h5 class="m-0 fw-bold text-danger">
                  {{ money(totalDeuda) }}
                </h5>
              </div>
            </div>

              <div class="col-sm-12 col-md-5">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                  ref="vuetable"
                  class="table-divided  table-responsive order-with-arrow"
                  :css="css.table"
                  :http-options="httpOptions"
                  :api-url="apiBase"
                  :reactive-api-url="true"
                  :fields="fields"
                  :per-page="perPage"
                  :query-params="makeQueryParams"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props" >
                  <b-dropdown
                      text="Opciones"
                      variant="outline-primary"
                      size="sm"
                  >
                    <router-link
                        :to="{
                        name: 'vistaCreditosVenta',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button
                      ><i class="bx bxs-show"></i>&nbsp;&nbsp;&nbsp;&nbsp;Ver
                        más
                      </b-dropdown-item-button>
                    </router-link>
                    <!-- <router-link
                      v-if="props.rowData.estado_pagado_v ==false"
                      :to="{
                        name: 'imprimirTicket',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button variant="outline-primary"
                        ><i class="bx bx-printer"></i
                        >&nbsp;&nbsp;&nbsp;&nbsp;Imprimir ticket
                      </b-dropdown-item-button>
                    </router-link> -->
                    <b-dropdown-item-button variant="outline-primary"
                      @click="reciboVenta(props.rowData.id)"
                      ><i class="bx bx-printer"></i
                      >&nbsp;&nbsp;&nbsp;&nbsp;Imprimir Recibo
                      </b-dropdown-item-button>
                    <b-dropdown-item-button
                        v-if="props.rowData.estado_pagado_v == false  && props.rowData.estado_venta ==true "
                        @click="onActionClicked('abonar-item', props.rowData)"
                    ><i class="bx bx-plus-medical"></i
                    >&nbsp;&nbsp;&nbsp;&nbsp;Abonar pago
                    </b-dropdown-item-button>
                    <!-- <b-dropdown-item-button
                      v-if="props.rowData.estado_pagado == false"
                      @click="
                        onActionClicked('desactivate-item', props.rowData)
                      "
                    >
                      <i class="fas fa-ban"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cancelar
                      crédito
                    </b-dropdown-item-button> -->
                  </b-dropdown>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_venta == true">
                    <span class="badge bg-success ms-1"
                    ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="empleado" slot-scope="props">
                  {{props.rowData.user? props.rowData.user.empleado.persona.nombre_persona :''}}
                  {{props.rowData.user? props.rowData.user.empleado.persona.apellido_persona:'' }}
                </div>
                <div slot="cliente" slot-scope="props">
                  {{
                    props.rowData.cliente_rapido ? props.rowData.cliente_rapido : ''
                  }}
                  {{
                    props.rowData.cliente ? props.rowData.cliente.persona.nombre_persona + (props.rowData.cliente.persona.apellido_persona? ' ' + props.rowData.cliente.persona.apellido_persona: '') : ''
                  }}
                </div>
                <div slot="estado3" slot-scope="props">
                  <h5 v-if="props.rowData.estado_pagado_v == true">
                    <span class="badge bg-success ms-1 "
                    ><strong>PAGADO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>PENDIENTE</strong></span
                    >
                  </h5>
                </div>
                <div slot="usuario" slot-scope="props">
                  <h6 v-if="props.rowData.estado_autoriza == false">
                    {{ props.rowData.usuario_autoriza.usuario }}
                  </h6>
                  <h6 v-else>Sin Autorizar</h6>
                </div>

                <div slot="fechac" slot-scope="props">
                  {{ showDate(props.rowData.fecha_venta_v) }}
                </div>

                <div slot="fechalimite" slot-scope="props">
                  {{ showDate(fechaLimite(props.rowData)) }}
                </div>
                <div slot="cuota" slot-scope="props">
                  {{ money(cuota(props.rowData)) }}
                </div>
                <div slot="saldo" slot-scope="props">
                  {{ money(props.rowData.saldo_credito_v) }}
                </div>
                <div slot="total" slot-scope="props">
                  {{ money(props.rowData.total) }}
                </div>
              </vuetable>
              <div style="padding-top:10px">
                <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>


<style scoped>
/* Contenedor general */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
  padding: 15px;
}

.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

/* Botones */
.btn-rounded {
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.btn-rounded:hover {
  transform: scale(1.05);
}

/* Tabla responsiva */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Desplazamiento suave en dispositivos táctiles */
}

.table-divided {
  width: 100%;
  border-collapse: collapse;
}

.table-divided th,
.table-divided td {
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;
  white-space: nowrap; /* Evita que el contenido se ajuste automáticamente */
}

/* Dropdown y inputs */
.dataTables_length,
.dataTables_filter {
  margin-bottom: 20px;
}

.dataTables_length select,
.dataTables_filter input {
  font-size: 0.9rem;
  padding: 5px 10px;
  border-radius: 5px;
}

/* Ajustes para tablets */
@media (max-width: 992px) {
  .card-title {
    font-size: 1.3rem;
  }

  .btn-rounded {
    font-size: 0.85rem;
    padding: 7px 15px;
  }

  .dataTables_length,
  .dataTables_filter {
    text-align: center;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.9rem;
    padding: 6px;
  }
}

/* Ajustes para móviles */
@media (max-width: 576px) {
  .card {
    padding: 10px;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .btn-rounded {
    font-size: 0.8rem;
    padding: 5px 10px;
  }

  .dataTables_length,
  .dataTables_filter {
    text-align: center;
    margin-bottom: 15px;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.8rem;
    padding: 4px;
  }
}
</style>
